import FilesCard from '@components/cards/files/Files.card';
import { alpha, Divider, Stack, Typography } from '@mui/material';
import {
    AiScheduleObj,
    AuditOperation,
    CreateAuditOperation
} from '@store/audits/audits-operation/audits-operation.model';
import { useTranslation } from 'react-i18next';

interface ContainerComponentProps {
    isExpended?: boolean;
    auditOperation?: CreateAuditOperation;
    oldValue?: AuditOperation;
    frequency: AiScheduleObj | undefined;
}

const PrecoContainerComponent = (props: ContainerComponentProps) => {
    const { isExpended, auditOperation, oldValue, frequency } = props;
    const { t } = useTranslation();

    return (
        <Stack justifyContent="center" alignItems="start" height="100%">
            <Stack direction="row" alignItems="center" spacing={4}>
                {[
                    { title: 'type', value: auditOperation?.container?.name || auditOperation?.containerCustom || '-', oldValue: oldValue?.container?.name || oldValue?.containerCustom },
                    { title: 'quantité', value: auditOperation?.quantity ?? '-', oldValue: oldValue?.quantity },
                    { title: 'propriété', value: auditOperation?.ownedBy ?? '-', oldValue: oldValue?.ownedBy },
                    { title: 'localisation', value: auditOperation?.description ?? '-', oldValue: oldValue?.description }
                ].map((el, idx) => {
                    return (el.value != '' && (<Stack key={idx} direction="row" alignItems="center" spacing={1.5}>
                        <Typography fontSize="14px" fontWeight={400} color="#868F9C">
                            {el.title}
                        </Typography>
                        <Stack>
                            <Stack sx={{
                                backgroundColor: (el.oldValue !== el.value) ? alpha('#F2A93B', 0.14) : '#E9EBEE',
                                borderRadius: '1px',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '6px 10px',
                                position: 'relative'
                            }}>
                                <Typography fontSize="12px" fontWeight={400}
                                    color={(el.oldValue !== el.value) ? '#F2A93B' : '#192133'}>
                                    {el.value}
                                </Typography>
                            </Stack>
                            {(el.oldValue !== el.value) && (
                                <Stack sx={{
                                    borderRadius: '1px',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '6px 10px',
                                    position: 'relative'
                                }}>
                                    {(
                                        <Typography fontSize="10px" fontWeight={400} color="#868F9C">
                                            {el.oldValue}
                                        </Typography>
                                    )}
                                </Stack>
                            )}
                        </Stack>
                    </Stack>));
                }
                )}
            </Stack>
            {
                isExpended && (
                    <Stack mt="16px" spacing={1.5} width="100%">
                        <Divider style={{ border: `1px solid ${alpha('#868F9C', 0.22)}` }} />
                        <Stack spacing={2} pb="10px">
                            <Typography fontSize="11px" fontWeight={500} color="#192133">{t('audits.waste')}</Typography>
                            <Stack direction="row" alignItems="center" spacing={5}>
                                {[{
                                    title: 'déchet',
                                    value: auditOperation?.waste?.name || auditOperation?.wasteCustom || '-',
                                    oldValue: oldValue?.waste?.name || oldValue?.wasteCustom
                                },
                                // {title: 'typologie', value: 'Typologie', oldValue: 'typologie'},
                                {
                                    title: 'volume',
                                    value: auditOperation?.annualEstimatedWeightInTons ?? '-',
                                    oldValue: oldValue?.annualEstimatedWeightInTons
                                },
                                {
                                    title: 'unité',
                                    value: auditOperation?.wasteUnitName ?? '-',
                                    oldValue: oldValue?.wasteUnitName
                                }].map((el, idx) => {
                                    return (
                                        (el.value != '' && el.value != '-') && (
                                            <Stack key={idx} direction="row" alignItems="center" spacing={1.5}>
                                                <Typography fontSize="14px" fontWeight={400} color="#868F9C">
                                                    {el.title}
                                                </Typography>
                                                <Stack sx={{
                                                    backgroundColor: (el.oldValue !== el.value) ? alpha('#F2A93B', 0.14) : '#E9EBEE',
                                                    borderRadius: '1px',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '6px 10px',
                                                    position: 'relative'
                                                }}>
                                                    <Typography fontSize="12px" fontWeight={400}
                                                        color={(el.oldValue !== el.value) ? '#F2A93B' : '#192133'}>
                                                        {el.value}
                                                    </Typography>
                                                    {(el.oldValue !== el.value) && (
                                                        <Typography sx={{ position: 'absolute', top: '27px' }} fontSize="10px"
                                                            fontWeight={400}
                                                            color="#868F9C">{el.oldValue}</Typography>
                                                    )}
                                                </Stack>
                                            </Stack>
                                        )
                                    );
                                }
                                )}
                            </Stack>
                        </Stack>
                        {auditOperation?.schedule && (
                            <>
                                <Divider style={{ border: `1px solid ${alpha('#868F9C', 0.22)}` }} />
                                <Stack spacing={2} pb="10px">
                                    <Typography fontSize="11px" fontWeight={500}
                                        color="#192133">{t('audits.collect')}</Typography>
                                    <Stack direction="row" alignItems="center" spacing={5}>
                                        {auditOperation?.schedule && (
                                            frequency?.frequencyItem.map((el, idx) => (
                                                <Stack key={idx} direction="row" alignItems="center" spacing={1.5}>
                                                    <Typography fontSize="14px" fontWeight={400} color="#868F9C">
                                                        {el.title}
                                                    </Typography>
                                                    <Stack sx={{
                                                        backgroundColor: (el.oldValue !== el.value) ? alpha('#F2A93B', 0.14) : '#E9EBEE',
                                                        borderRadius: '1px',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        padding: '6px 10px',
                                                        position: 'relative'
                                                    }}>
                                                        <Typography fontSize="12px" fontWeight={400}
                                                            color={(el.oldValue !== el.value) ? '#F2A93B' : '#192133'}>
                                                            {el.value}
                                                        </Typography>
                                                        {(el.oldValue !== el.value) && (
                                                            <Typography sx={{ position: 'absolute', top: '27px' }}
                                                                fontSize="10px" fontWeight={400}
                                                                color="#868F9C"
                                                            >
                                                                {el.oldValue}
                                                            </Typography>
                                                        )}
                                                    </Stack>
                                                </Stack>
                                            ))
                                        )}
                                    </Stack>
                                </Stack>
                            </>
                        )
                        }
                        {auditOperation?.documents?.length !== 0 && auditOperation?.documents?.map((photo, index) => (
                            !auditOperation?.deletedDocuments?.includes(photo.id) && (
                                photo.name && (
                                    <FilesCard key={index} document={photo} />
                                )
                            )
                        ))}
                    </Stack>
                )
            }
        </Stack>
    );
};

export default PrecoContainerComponent;
